export default __webpack_public_path__ + "static/media/8.55d879bf.svg";